// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__o2E21","tips":"styles_tips__1dXd3"};